// extracted by mini-css-extract-plugin
module.exports = {"header":"header_header__3IDeT","logo":"header_logo__km4sf"};